export default __webpack_public_path__ + "static/media/HindiDiwas1.59c23abe.JPG";